const parseEnergyToJoules = value => {
  if (typeof value === 'number') return value;

  if (typeof value === 'string') {
    const match = value.match(/^(\d*\.?\d+)\s*(kj|j|cal|kcal)$/i);
    if (match) {
      const numericValue = parseFloat(match[1]);
      const unit = match[2].toLowerCase();
      return unit === 'kj' ? numericValue * 1000 : numericValue;
    }
  }

  return 0;
};

const calculateCustomisationEnergy = node => {
  let total = 0;

  if (!node.customisations) return null;

  for (const category of node.customisations) {
    for (const product of category.products) {
      const { current = 0, initial = 0 } = product.count ?? {};
      const parsedEnergy = parseEnergyToJoules(product.energyInformation);

      if (current > 0 && initial === 0 && parsedEnergy > 0) {
        total += parsedEnergy * current;
      }

      total += calculateCustomisationEnergy(product);
    }
  }

  return total;
};

const calculateCustomiseEnergy = product => {
  const baseEnergy = parseEnergyToJoules(product.energyInformation);
  const additionalEnergy = calculateCustomisationEnergy(product);
  const total = baseEnergy + additionalEnergy;
  return total >= 1000 ? `${Math.ceil(total / 1000)}kJ` : `${total}J`;
};

const calculateComboEnergy = product => {
  let total = 0;

  if (product.options) {
    for (const option of product.options) {
      const selectedProduct = option.products?.find(p => (p.count?.current ?? 0) > 0);

      if (selectedProduct) {
        total += parseEnergyToJoules(selectedProduct.energyInformation);

        total += calculateCustomisationEnergy(selectedProduct) || 0;
      }
    }
  }

  return total >= 1000 ? `${Math.ceil(total / 1000)}kJ` : `${total}J`;
};

const calculateTotalEnergy = product => {
  const { energyInformation, type } = product;
  if (!energyInformation) return null;

  if (type === 'customise') {
    return calculateCustomiseEnergy(product);
  }

  if (type === 'combo') {
    return calculateComboEnergy(product);
  }

  return energyInformation;
};

export { parseEnergyToJoules, calculateTotalEnergy };
